import { useState, useEffect } from "react";

/**
 * Live countdown to UTC midnight (next daily puzzle).
 * Auto-reloads the page when the timer reaches zero.
 *
 * @returns {JSX.Element} A sidebar countdown display ("Next puzzle: XXh XXm XXs").
 */
export default function CountdownTimer() {
  const calculateTimeLeft = () => {
    const now = new Date();
    const tomorrow = new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1)
    );
    const difference = tomorrow - now;

    if (difference <= 0) {
      window.location.reload();
      return "00h 00m 00s";
    }

    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / 1000 / 60) % 60);
    const seconds = Math.floor((difference / 1000) % 60);

    return `${hours.toString().padStart(2, "0")}h ${minutes
      .toString()
      .padStart(2, "0")}m ${seconds.toString().padStart(2, "0")}s`;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="sidebar-countdown">
      <div>Next puzzle:</div>
      <div className="countdown-time">{timeLeft}</div>
    </div>
  );
}
